export const giveGiftParams = {
  designation: 'd',
  campaignPage: 'c',
  amount: 'a',
  frequency: 'f',
  day: 'dd',
  month: 'm',
  campaignCode: 'CampaignCode',
};
